import React, { useState, useEffect, useRef } from "react";
import { DatePicker, Select, Form, Typography } from "antd";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import ThumbDownAltOutlinedIcon from "@mui/icons-material/ThumbDownAltOutlined";
import { SyncOutlined, OpenAIOutlined } from "@ant-design/icons";

import Attachment from "../../Images/attachment.svg";


import "./probing.css";

import sourceArrow from "../../Images/sourceArrow.svg";

import ProgressOne from "../../Images/progressOne.svg";
import ProgressTwoGrey from "../../Images/progressTwoGrey.svg";
import ProgressThreeGrey from "../../Images/progressThreeGrey.svg";
import ProgressFourGrey from "../../Images/progressFourGrey.svg";
import ProgressFiveGrey from "../../Images/progressFiveGrey.svg";
import ProgressSixGrey from "../../Images/progressSixGrey.svg";

import ProgressTwoGreen from "../../Images/progressTwoGreen.svg";
import ProgressThreeGreen from "../../Images/progressThreeGreen.svg";
import ProgressFourGreen from "../../Images/progressFourGreen.svg";
import ProgressFiveGreen from "../../Images/progressFiveGreen.svg";
import ProgressSixGreen from "../../Images/progressSixGreen.svg";

import masterResetNoIcon from "../../Images/masterResetNoIcon.svg";
import ImageGallery from "../ImageGallery/ImageGallery";
import SectionOne from "../../CommonUtils/TroubleshootingSteps/SectionOne";
import SectionTwo from "../../CommonUtils/TroubleshootingSteps/SectionTwo";
import SectionThree from "../../CommonUtils/TroubleshootingSteps/SectionThree";
import SectionFour from "../../CommonUtils/TroubleshootingSteps/SectionFour";
import SectionFive from "../../CommonUtils/TroubleshootingSteps/SectionFive";
import SectionSix from "../../CommonUtils/TroubleshootingSteps/SectionSix";
import LLM from "./LlmSteps/LLM";
import SystemCheck from "./LlmSteps/SystemCheck";
import Resolution from "./LlmSteps/Resolution";
import ProbingTab from "./LlmSteps/ProbingTab";
import CallLogs from "./LlmSteps/CallLogs";

import iconPlus from '../../Images/IconPlus.svg'
import iconMinus from '../../Images/IconMinus.svg'

const { Option } = Select;
const { Title } = Typography;

function ProbingMultiIntent(props) {
  const {
    setIsFeedbackPop,
    data,
    scrollToBottom,
    setMessageBoard,
    messageBoard,
    showMaximumChat,
  } = props;



  const responsesArray = data?.llm_response?.map((key) => key);
  const responseSource = data?.llm_response?.map((key) => ({
    webpage: key?.webpage,
    source_title: key?.source_title
}));
  
  
  

  const [probingCheck, setProbingCheck] = useState([]);

  const [toggleOption, setToggleOption] = useState({});
  const [masterResetTap, setmasterResetTab] = useState(false);
  const [errorTabEnable, setErrorTabEnable] = useState(false);
  const [workOrderTab, setWorkOrderTab] = useState(false);
  const [toggleListIcons, setToggleListIcons] = useState({});

  // State to track the selected option for each set
  const [selectedOptions, setSelectedOptions] = useState([
    true,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  //------
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);

  const handleDateChange = (date) => {
    setDate(date);
  };

  const handleTimeChange = (value) => {
    setTime(value);
  };
  //----

  const handleRadioChange = (tabId, key) => {
    setProbingCheck((prevState) => {
      const updatedState = { ...prevState };

      if (!updatedState[tabId]) {
        updatedState[tabId] = [];
      }

      if (updatedState[tabId].includes(key)) {
        updatedState[tabId] = updatedState[tabId].filter((item) => item !== key);
      } else {
        updatedState[tabId] = [...updatedState[tabId], key];
      }

      return updatedState;
    });
  };
  
  
  

  const options = [
    ProgressOne,
    selectedOptions[1] ? ProgressTwoGreen : ProgressTwoGrey,
    selectedOptions[2] ? ProgressThreeGreen : ProgressThreeGrey,
    selectedOptions[3] ? ProgressFourGreen : ProgressFourGrey,
    selectedOptions[4] ? ProgressFiveGreen : ProgressFiveGrey,
    selectedOptions[5] ? ProgressSixGreen : ProgressSixGrey,
  ];

  const selections = [
    { id: 1, name: "yesNo" },
    { id: 2, name: "activeDeactive" },
    { id: 3, name: "yesNo" },
    { id: 4, name: "activeDeactive" },
    { id: 5, name: "yesNo" },
    { id: 6, name: "activeDeactive" },
    // Add more groups as needed
  ];

  // Function to handle button click and update selectedOptions state
  const handleButtonClick = (id, option) => {
    setToggleOption((prevOptions) => ({
      ...prevOptions,
      [id]: option,
    }));
    // Perform other actions based on the toggle option clicked
  };

  useEffect(() => {
    // Call scrollToBottom on selectedOptions update
    scrollToBottom();
  }, [selectedOptions]);

  //switching
  const [tabKey, setTabKey] = useState("default");
  const boxRef = useRef();

  useEffect(() => {
    if (errorTabEnable) {
      setTabKey("errorTabEnable");
    } else if (masterResetTap) {
      setTabKey("masterResetTap");
    } else if (workOrderTab) {
      setTabKey("workOrderTab");
    } else {
      setTabKey("default");
    }
  }, [errorTabEnable, masterResetTap, workOrderTab]);

  useEffect(() => {
    if (boxRef.current) {
      const box = boxRef.current;
      box.classList.add("fade-in");
      const timeout = setTimeout(() => {
        box.classList.remove("fade-in");
      }, 500);
      return () => clearTimeout(timeout);
    }
  }, [tabKey]);

  const handleToggle = (index) => {
    setToggleListIcons((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const errorTab = () => {
    return (
      <div ref={boxRef} className="box">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="error-head">Error Message - No Signal</span>
          <button
            onClick={() => {
              // handleButtonClick(1, "no");
              setMessageBoard(false);
              setErrorTabEnable(false);
            }}
            className={`option-button`}
          >
            Back
          </button>
        </div>
        <div className="error-container">
          <div className="error-side-nav">
            {options.map((option, index) => (
              <img
                key={index}
                src={option}
                style={{
                  height: "clamp(32px, 4vw, 72px)",
                  width: "clamp(16px, 4vw, 32px)",
                }}
              ></img>
            ))}
          </div>
          <div className="error-message-container">
            {/* {getSectionOne()} */}
            <SectionOne
              handleButtonClick={handleButtonClick}
              setSelectedOptions={setSelectedOptions}
              selectedOptions={selectedOptions}
              toggleOption={toggleOption}
              setMessageBoard={setMessageBoard}
              setErrorTabEnable={setErrorTabEnable}
              showMaximumChat={showMaximumChat}
            />

            {selectedOptions[1] && (
              <>
                <div className="error-line"></div>
                {/* {getSectionTwo()} */}
                <SectionTwo
                  handleButtonClick={handleButtonClick}
                  setSelectedOptions={setSelectedOptions}
                  selectedOptions={selectedOptions}
                  toggleOption={toggleOption}
                  setMessageBoard={setMessageBoard}
                  setErrorTabEnable={setErrorTabEnable}
                  showMaximumChat={showMaximumChat}
                />
              </>
            )}
            {selectedOptions[2] && (
              <>
                <div className="error-line"></div>
                {/* {getSectionThree()} */}
                <SectionThree
                  handleButtonClick={handleButtonClick}
                  setSelectedOptions={setSelectedOptions}
                  selectedOptions={selectedOptions}
                  toggleOption={toggleOption}
                  setMessageBoard={setMessageBoard}
                  setErrorTabEnable={setErrorTabEnable}
                  showMaximumChat={showMaximumChat}
                />
              </>
            )}
            {selectedOptions[3] && (
              <>
                <div className="error-line"></div>
                {/* {getSectionFour()} */}
                <SectionFour
                  handleButtonClick={handleButtonClick}
                  setSelectedOptions={setSelectedOptions}
                  selectedOptions={selectedOptions}
                  toggleOption={toggleOption}
                  setMessageBoard={setMessageBoard}
                  setErrorTabEnable={setErrorTabEnable}
                  showMaximumChat={showMaximumChat}
                />
              </>
            )}
            {selectedOptions[4] && (
              <>
                <div className="error-line"></div>
                {/* {getSectionFive()} */}
                <SectionFive
                  handleButtonClick={handleButtonClick}
                  setSelectedOptions={setSelectedOptions}
                  selectedOptions={selectedOptions}
                  toggleOption={toggleOption}
                  setMessageBoard={setMessageBoard}
                  setErrorTabEnable={setErrorTabEnable}
                  setmasterResetTab={setmasterResetTab}
                  showMaximumChat={showMaximumChat}
                />
              </>
            )}
            {selectedOptions[5] && (
              <>
                <div className="error-line"></div>
                {/* {getSectionSix()} */}
                <SectionSix
                  handleButtonClick={handleButtonClick}
                  setSelectedOptions={setSelectedOptions}
                  selectedOptions={selectedOptions}
                  toggleOption={toggleOption}
                  setMessageBoard={setMessageBoard}
                  setErrorTabEnable={setErrorTabEnable}
                  setWorkOrderTab={setWorkOrderTab}
                  showMaximumChat={showMaximumChat}
                />
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  const resetTab = () => {
    return (
      <div ref={boxRef} className="box">
        <span className="error-head">Master Reset Procedure</span>
        <div className="error-container">
          <div className="error-side-nav">
            <img
              key={"1"}
              src={masterResetNoIcon}
              style={{ height: "72px", width: "32px" }}
            ></img>
          </div>
          <div className="error-message-container">
            <div style={{ paddingTop: "0px" }} className="error-message-head1">
              Check if the subscriber want to perform “Master Reset”
            </div>
            <div style={{ gap: "8px", display: "flex", marginTop: "22px" }}>
              <button
                onClick={() => {
                  handleButtonClick(4, "yes");
                }}
                className={`option-button ${
                  toggleOption[4] === "yes" ? "clicked" : ""
                }`}
                // disabled={selectedOptions[4]}
              >
                Yes
              </button>
              <button
                onClick={() => {
                  handleButtonClick(4, "no");
                }}
                className={`option-button ${
                  toggleOption[4] === "no" ? "clicked" : ""
                }`}
                // disabled={selectedOptions[4]}
              >
                No
              </button>
            </div>
            <button
              className="submit-wo"
              onClick={() => {
                setmasterResetTab(false);
                setErrorTabEnable(true);
              }}
              style={{ width: "180px", marginTop: "12px" }}
            >
              Go Back to Troubleshoot
            </button>
            <div className="error-message-head2">
              1. Press "Organizer / Setting" button from the TataPlay remote
            </div>
            <div className="error-message-head2">
              2. Select "System Settings" from the menu.
            </div>
            <ImageGallery />
          </div>
        </div>
      </div>
    );
  };

  const createWorkOrderTab = () => {
    return 
    // (
      // <div ref={boxRef} className="box">
      //   <span className="error-head">CREATE WORK ORDER</span>
      //   <div style={{ top: "0px" }} className="error-container">
      //     <div
      //       style={{ backgroundColor: "#eff0ee" }}
      //       className="error-message-container"
      //     >
      //       <div className="error-message-head2">
      //         We are sorry for the inconvenience!
      //       </div>
      //       <div className="error-message-head2">
      //         Visit Charges are subject to your account level warranty. Material
      //         charges if applicable will be informed during the installer visit.
      //       </div>
      //       <div className="error-message-head2">
      //         Please select your preferred date & time and we will send our
      //         technician to fix this issue for you!
      //       </div>

      //       <div>
      //         <Form style={{ width: "50%" }} layout="vertical">
      //           <Title
      //             style={{ fontSize: "14px" }}
      //             className="error-message-head2"
      //             level={4}
      //           >
      //             Select Date
      //           </Title>
      //           <Form.Item>
      //             <DatePicker
      //               onChange={handleDateChange}
      //               style={{ width: "100%" }}
      //               placeholder="Select Date"
      //             />
      //           </Form.Item>

      //           <Title
      //             style={{ fontSize: "14px" }}
      //             className="error-message-head2"
      //             level={4}
      //           >
      //             Select Time
      //           </Title>
      //           <Form.Item>
      //             <Select
      //               onChange={handleTimeChange}
      //               placeholder="Select Time"
      //               style={{ width: "100%" }}
      //             >
      //               <Option value="10 AM to 12 PM">10 AM to 12 PM</Option>
      //               <Option value="12 PM to 3 PM">12 PM to 3 PM</Option>
      //               <Option value="4 PM to 6 PM">4 PM to 6 PM</Option>
      //               <Option value="6 PM to 8 PM">6 PM to 8 PM</Option>
      //             </Select>
      //           </Form.Item>
      //         </Form>
      //       </div>
      //       <div style={{ display: "flex", gap: "10px" }}>
      //         <button
      //           className="submit-wo"
      //           style={{ width: showMaximumChat ? "20%" : "25%" }}
      //         >
      //           Submit
      //         </button>
      //         <button
      //           className="cancel-wo"
      //           style={{ width: showMaximumChat ? "25%" : "35%" }}
      //           onClick={() => {
      //             setWorkOrderTab(false);
      //             setErrorTabEnable(true);
      //           }}
      //         >
      //           Cancel WO
      //         </button>
      //       </div>
      //     </div>
      //   </div>
      // </div>
    // );
  };

  const switchTabs = () => {
    switch (true) {
      case errorTabEnable:
        return errorTab();
      case masterResetTap:
        return resetTab();
      case workOrderTab:
        return createWorkOrderTab();
      default:
        return null;
    }
  };

  const getPadding = (isToggled) => {
    if (showMaximumChat) {
      return isToggled ? '16px 16px 0px 16px' : '16px';
    } else {
      return isToggled ? '8px 16px 0px 16px' : '8px 16px';
    }
  };

  return (
    <div>
      {messageBoard ? (
        <>{switchTabs()}</>
      ) : (
        <div>
          {data?.llm_response?.llm_response && <span>{data?.message}</span>}
          {responsesArray.map((key, index) => {
            const isToggled = toggleListIcons[index];
            return (
              <React.Fragment key={index}>
                {responsesArray?.length > 1 && (
                <div
                  style={{
                    height: showMaximumChat && "28px",
                    borderRadius: isToggled ? "8px 8px 0px 0px" : "8px",
                    marginBottom: !isToggled && "16px",
                    padding: getPadding(isToggled),
                  }}
                  className={`channel-list-head ${isToggled ? "no-hover" : "hover-pop"}`}
                >
                  <div
                    style={{ display: "flex", width: "100%", cursor: "pointer" }}
                    onClick={() => handleToggle(index)}
                  >
                    <span
                      style={{ fontWeight: "700", width: "90%" }}
                      className="channel-list-count"
                    >
                      {key?.source_title}
                    </span>
                    <img
                      style={{ height: "26px", width: "24px" }}
                      src={isToggled ? iconMinus : iconPlus}
                      alt={isToggled ? "Minus Icon" : "Plus Icon"}
                    />
                  </div>
                </div>
                )}


                {(isToggled || responsesArray?.length === 1) && (
                  <div className="list-of-channels">
                    {key?.llm_response && key?.breadcrumb_1 != 'CHGS' && key?.llm_response != 'NO_Output' && (
                      <LLM item={key?.llm_response}/>
                    )}
                    {key?.probing &&( key?.breadcrumb_1 === 'CHGS' || key?.breadcrumb_1 === 'chg' )   &&(
                      <ProbingTab
                        item={key?.probing} 
                        probingCheck={probingCheck[index] || []} 
                        handleRadioChange={handleRadioChange} // Pass the function directly
                        tabId={index}
                      />
                    )}
                    {key?.system_check && ( key?.breadcrumb_1 === 'CHGS' || key?.breadcrumb_1 === 'chg' ) && (
                      <SystemCheck item={key?.system_check } />
                    )}
                    {key?.resolution &&  ( key?.breadcrumb_1 === 'CHGS' || key?.breadcrumb_1 === 'chg' ) && (
                      <Resolution item={key?.resolution} />
                    )}
                    {(key?.Call_log_type ||
                      key?.call_log_type ||
                      key?.Call_log_area ||
                      key?.call_log_area ||
                      key?.Call_log_sub_area ||
                      key?.call_log_sub_area ||
                      key?.Call_log_resolution_code ||
                      key?.call_log_resolution_code
                      ) &&  (( key?.breadcrumb_1 === 'CHGS' || key?.breadcrumb_1 === 'chg' ))&& (
                      <CallLogs
                        item={key}
                        showMaximumChat={showMaximumChat}
                      />
                    )}
                  </div>
                )}
              </React.Fragment>
            );
          })}
          {!showMaximumChat && responseSource && (
            <div style={{ marginTop: "20px", marginLeft: "10px" }}>
              <span className="sources-text">Sources</span>
              {responseSource.map((key, idx) => (
                <p style={{ margin: "5px" }} key={idx}>
                  <a
                    href={key?.webpage}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      color: "#220046",
                      textDecoration: "none",
                    }}
                  >
                    <div>{key?.source_title || key?.webpage}</div>
                    <img
                      style={{ width: "20px" }}
                      src={sourceArrow}
                      alt="srcIcon"
                    />
                  </a>
                </p>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ProbingMultiIntent;
